<div style="padding: 10px;">
    <p class="tittle">EDITAR DESCUENTO</p>

    <div style="padding-bottom: 15px;">
        <b>Grupo:</b> {{nombre}}
        <br>
        <b>Descuento:</b> {{dto}}%
        <br>
        <b>Curso:</b> {{curso}}
        <br>
        <b>Salon:</b> {{salon}}
        <br>
        <b>Fecha de Inicio:</b> {{fechaInicio}}
        <br>
        <b>Estado:</b> {{estado}}
        <br>
        <b>Modalidad:</b> {{modalidad}}
        <br>
        <b>C.Min:</b> {{cupoMinimo}}
        <br>
        <b>C.Max:</b> {{cupoMaximo}}
        <br>
        <b>Cant. inscritos:</b> {{inscritos}}
        <br>
        <b>Carga horaria:</b> {{cargaHoraria}}
        <br>
        <b>Horario:</b> {{horario}}
        <br>
    </div>

    <div class="inputs">
        <div>
            <mat-form-field appearance="outline">
                <mat-label><b>Sumar descuento</b></mat-label>
                <mat-select [(value)]="selectedSuma" class="text" (selectionChange)="sumaID($event.value)">
                    <mat-option id="suma" *ngFor="let suma of sumas" [value]="suma.value">
                        {{suma.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="outline">
                <mat-label><b>Restar descuento</b></mat-label>
                <mat-select [(value)]="selectedResta" class="text" (selectionChange)="restaID($event.value)">
                    <mat-option id="resta" *ngFor="let resta of restas" [value]="resta.value">
                        {{resta.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="buttons">
        <div></div>
        <div>
            <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="boton-aceptar"
            (click)="editDto()">
                Aceptar
            </button>
        </div>
        <div><button mat-button mat-dialog-close class="boton-cancelar">Cancelar</button></div>
    </div>
</div>